import { Breadcrumbs, Link, Typography } from "@mui/material";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import FormContainer from "../../../../../common/components/form_container";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useRevisaoCadastroGerenciarViewModel } from "../../viewModels/revisao_cadastrogerenciar_view_model";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { TransferList } from "../../components/transfer_list";
import { useMemo } from "react";
import { DefaultFormRadioGroupInput } from "../../../../../common/components/default_form_radio_group_input";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";
import { BackButton } from "../../../../../common/components/back_button";
import { DefaultFormDownloadInput } from "../../../../../common/components/default_form_download_input";

export const Revisao_cadastrogerenciar = () => {
  const viewModel = useRevisaoCadastroGerenciarViewModel();

  const analiseOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Aberta',
        style: {
          backgroundColor: '#f3565d',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Em Análise',
        style: {
          backgroundColor: '#f1c40f',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 2,
        label: 'Encerrada',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      }

    ];
  }, [
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <BackButton onClick={() => window.history.back()} />
            </div>
          }
        />
      </PageTopBar>

      <form onSubmit={viewModel.handleSubmitProjetoRevisao}>
        <div className=" flex w-full gap-6 flex-col py-10 px-4 mb-16 ">
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit">
              Projetos
            </Link>
            <Typography className="text-primary-green ">Gerenciar Solicitação de Revisão</Typography>
          </Breadcrumbs>

          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium dark:dark:text-zinc-100 ">
              Gerenciar Solicitação de Revisão
            </h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>

          <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
            <FormContainer title="Dados da Aprovação" arrangement="fullRow" border>
              <div className="w-full flex flex-col  gap-4">

                <DefaultFormRadioGroupInput
                  name='status'
                  label='Status'
                  options={analiseOptions}
                  reactHookForm={viewModel.hookForm}
                />

                <div className="w-full grid grid-cols-2 gap-4">
                  <DropDownFuncionario
                    name="idFuncionarioAprovacao"
                    label="Responsável pela Análise"
                    required
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="w-full grid grid-cols-2 gap-4">
                  <FormDatePickerInput
                    name="dataAprovacao"
                    label="Data Inicio"
                    required
                    reactHookForm={viewModel.hookForm}
                  />

                  <FormDatePickerInput
                    name="dataTermino"
                    label="Data Termino"
                    required
                    reactHookForm={viewModel.hookForm}
                  />

                </div>

                <DefaultFormInput
                  name="observacoesAprovacao"
                  label="Análise"
                  multiline
                  rows={3}
                  reactHookForm={viewModel.hookForm}
                />
              </div>

            </FormContainer>

            <fieldset disabled={true}>

              <FormContainer title="Detalhes da Solicitação de Revisão" arrangement="fullRow" border>
                <div className="w-full flex flex-col  gap-4">
                  <div className="w-full grid grid-cols-2 gap-4">
                    <DropDownCentroCusto
                      name="idCentroCusto"
                      label="Centro de Custo"
                      required
                      readOnly
                      reactHookForm={viewModel.hookForm}
                    />

                    <FormDatePickerInput
                      name="dataSolicitacao"
                      label="Data Solicitação"
                      required
                      readOnly
                      reactHookForm={viewModel.hookForm}
                    />

                  </div>

                  <div className="w-full grid grid-cols-2 gap-4">
                    <DefaultFormAutocomplete
                      name='idProjeto'
                      label='Projeto'
                      readOnly
                      options={viewModel.ddlProjetos ?? []}
                      getOptionKey={x => x.id}
                      getOptionLabel={x => x.title}
                      reactHookForm={viewModel.hookForm}

                    />

                    <DropDownFuncionario
                      name="idFuncionarioSolicitante"
                      label="Solicitante"
                      required
                      readOnly
                      reactHookForm={viewModel.hookForm}
                    />

                  </div>

                  <DefaultFormInput
                    name="observacoesSolicitacao"
                    label="Descrição"
                    readOnly
                    multiline
                    rows={3}
                    reactHookForm={viewModel.hookForm}
                  />


                </div>
              </FormContainer>

              {/* ARQUIVOS */}
              <FormContainer title="Anexar Arquivos" arrangement="fullRow" border>
                <>
                  <div className="flex w-full">
                    <DefaultFormDownloadInput
                      name='arquivo1'
                      nameLimparFlag='limparArquivo1'
                      saving={viewModel.saving}
                      filename={viewModel.selectedProjetoRevisao?.nomeArquivo1 ?? null}
                      readOnly={true}
                      maxFilenameSize={70}
                      reactHookForm={viewModel.hookForm}
                      isDeleteFileEnabled={false}
                      onDeleteFile={() => { }}
                      onDownloadFile={(_) => {
                        if (viewModel.selectedProjetoRevisao && viewModel.selectedProjetoRevisao.nomeArquivo1) {
                          viewModel.handleDownloadArquivo(viewModel.selectedProjetoRevisao.nomeArquivo1, 1);
                        }
                      }}
                    />
                  </div>

                  <div className="flex w-full">
                    <DefaultFormDownloadInput
                      name='arquivo2'
                      nameLimparFlag='limparArquivo2'
                      saving={viewModel.saving}
                      filename={viewModel.selectedProjetoRevisao?.nomeArquivo2 ?? null}
                      readOnly={true}
                      maxFilenameSize={70}
                      isDeleteFileEnabled={false}
                      reactHookForm={viewModel.hookForm}
                      onDeleteFile={() => { }}
                      onDownloadFile={(_) => {
                        if (viewModel.selectedProjetoRevisao && viewModel.selectedProjetoRevisao.nomeArquivo2) {
                          viewModel.handleDownloadArquivo(viewModel.selectedProjetoRevisao.nomeArquivo2, 2);
                        }
                      }}
                    />
                  </div>
                </>

              </FormContainer>


              <FormContainer title="Disciplinas/Subdisciplinas" arrangement="fullRow" border>

                <TransferList
                  sourceList={viewModel.disciplinasNaoCadastradas}
                  destinationList={viewModel.disciplinasCadastradas}
                  sourceListTitle="Selecione as Disciplinas/Subdisciplinas"
                  destinationListTitle="Disciplinas/Subdisciplinas Selecionados"
                  getItemKey={(x) => x.idDisciplina}
                  getItemLabel={(x) => x.descricao}
                  onSelectionChange={viewModel.handleChangeDisciplinasLista}

                />

              </FormContainer>
            </fieldset>
          </div>
        </div>

        {
          <BottomBar>
            <div className="w-full h-full items-center justify-between flex p-4 gap-4">

              <div>
                {
                  isValidId(viewModel.selectedProjetoRevisao) &&
                  <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                    <span className="text-xs">
                      Historico de alterações
                    </span>
                  </PrimaryButton>
                }
              </div>

              <div className="w-full flex justify-end items-center gap-4 p-4">
                <div className="p-2 cursor-pointer font-semibold" onClick={() => window.history.back()}>
                  Cancelar
                </div>

                <div className="w-[130px]">
                  {viewModel.loading ? (
                    <PrimaryButton>Salvando...</PrimaryButton>
                  ) : (
                    <PrimaryButton type="submit" startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
                </div>
              </div>
            </div>
          </BottomBar>
        }

      </form >

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

    </>
  );
};
